import React, { useState } from "react"
import { Outlet } from "react-router"
import { AppFooter } from "@components/AppFooter"
import { AppHeader } from "@components/AppHeader/AppHeader"
import { AppSidebar } from "@components/AppSidebar/AppSidebar"
import { getSidebarDefaultOpen } from "@components/AppSidebar/sidebarState"
import { SidebarInset, SidebarProvider } from "@components/ui/sidebar"

export const Dashboard = ({ children }: { children: React.ReactNode }) => {
  // SidebarProvider only reads defaultOpen on mount
  const [defaultOpen] = useState(getSidebarDefaultOpen)

  return (
    <SidebarProvider defaultOpen={defaultOpen}>
      <AppSidebar />
      <SidebarInset className="tw:min-w-0">
        <AppHeader />
        <div className="tw:flex-1 tw:p-6">
          {children}
          <Outlet />
        </div>
        <AppFooter />
      </SidebarInset>
    </SidebarProvider>
  )
}
